export default function escapeStringForRegEx(expression: string): string {
    // escape any literal characters
    return escapeNewLinesForRegEx(
        expression.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&')
    );
}

export function escapeNewLinesForRegEx(expression: string): string {
    return expression.replace(/\n[\s]*/g, '[\n]+');
}
